var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPdfEditIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "16 4 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 24,
    r: 20,
    fill: "#FFF4EF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 24,
    r: 19.5,
    stroke: "#FC6328"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.05 18.0009L41.999 22.9511L30.449 34.4999H25.5V29.5497L37.05 18.0009ZM38.6997 16.3512L41.1742 13.8756C41.3929 13.6569 41.6896 13.534 41.999 13.534C42.3084 13.534 42.6051 13.6569 42.8238 13.8756L46.1243 17.1761C46.3431 17.3949 46.4659 17.6916 46.4659 18.0009C46.4659 18.3103 46.3431 18.607 46.1243 18.8257L43.6487 21.3002L38.6997 16.3512Z",
    fill: "#FC6328"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPdfEditIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/PDFEditIcon.a718c97e.svg";
export { ForwardRef as ReactComponent };